export const getUserTitle = (
  userInfo?: {
    firstName?: string;
    surname?: string;
    email?: string;
    userId?: string;
  },
  fallback = "-"
) => {
  const first = userInfo?.firstName?.trim() ?? "";
  const last = userInfo?.surname?.trim() ?? "";
  const fullName = `${first} ${last}`.trim();
  return fullName || userInfo?.email || userInfo?.userId || fallback;
};
